// extracted by mini-css-extract-plugin
export default {"component_ig":"GameCardsLine__component_ig--ig-QzLmp","line_ig":"GameCardsLine__line_ig--ig-sTeVW","titled_ig":"GameCardsLine__titled_ig--ig-WqJm9"};